interface MyButtonProps {
  active?: boolean;
  disabled?: boolean; // ✅ NEW
  label: string;
  styles?: string;
  topText?: string;
  onClick?: () => void;
}

export const MyButton: React.FC<MyButtonProps> = ({
  active,
  disabled = false,
  styles,
  label,
  topText,
  onClick,
}) => {
  return (
    <button
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      className={`
        ${styles}
        relative whitespace-nowrap rounded-full px-5 py-2 text-sm shadow-sm transition
        ${
          disabled
            ? "bg-gray-200 text-gray-400 cursor-not-allowed dark:bg-gray-700 dark:text-gray-400"
            : active
            ? "bg-black text-white"
            : "hover:bg-gray-100 dark:border dark:text-gray-100 dark:hover:bg-gray-600"
        }
      `}
    >
      {topText && (
        <div className="absolute -mt-4.5 text-[10px] text-black/60 dark:bg-gray-200 px-1 rounded-full">
          {topText}
        </div>
      )}
      {label}
    </button>
  );
};

export default MyButton;